import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TOAST_DEFAULTS = {
  position: "bottom-right",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const ToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        {...TOAST_DEFAULTS}
        autoClose={3000}
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss
        theme="light"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />
    </>
  );
};

export default ToastProvider;
